function Loading() {
  return (
    <div id="loading-wrapper" className="opacity-0 invisible">
      <svg
        className="logo-montion opacity-1"
        xmlns="http://www.w3.org/2000/svg"
        width="3.3364in"
        height="1.3825in"
        clipRule="evenodd"
        fillRule="evenodd"
        imageRendering="optimizeQuality"
        shapeRendering="geometricPrecision"
        textRendering="geometricPrecision"
        version="1.1"
        viewBox="0 0 4846 2050"
      >
        <polygon
          className="right-logo"
          fill="#EAEAEA"
          points="2530.7 737.79 3996.5 2008 4846 2008 2530.7 1.64"
        />
        <polygon
          className="left-logo"
          fill="#EAEAEA"
          points="849.51 2008 2317.3 736.15 2317.3 0 -0 2008"
        />
        <polygon
          className="center-logo"
          fill="#245B8F"
          points="1151.2 2008 2423 905.92 3694.9 2008"
        />
      </svg>
    </div>
  );
}

export default Loading;
